
import { registerFormInputComponent } from '@vendure/admin-ui/core';
import {ChannelAssignmentInputComponent} from "./channel-assignment-input.component";

export default [
    registerFormInputComponent('channel-assignment-input', ChannelAssignmentInputComponent),
];